<script>
import VueEditor  from '@/components/vue2-editor/VueEditor';
import StringUtils from '@/utils/stringUtils'

export default
{
    name: 'inline-editable-text',

    props:
    {
        editable:
        {
            type: Boolean,
            default: true
        },

        // bound to v-model.
        value:
        {
            type: String,
            default: ''
        },

        noHtml:
        {
            type: Boolean,
            default: false
        },

        maxLength:
        {
            type: Number,
            default: Infinity
        },

        placeholder:
        {
            type: String,
            default: undefined
        },
        showToolbar: { type: Boolean }
    },

    created ()
    {
        this.currentValue = this.value
    },

    render ()
    {
        return (
            <div class={`inline-editable-text ${this.showToolbar && this.isFocused ? 'has-toolbar' : ''}`} >
                <VueEditor ref='input' id='input' v-model={this.currentValue} placeholder={this.placeholderValue} show-toolbar={true}
                    disabled={!this.editable} use-markdown-shortcuts={true} max-length={this.maxLength} on-focus={this.onFocused} on-blur={this.onBlurred} />
            </div>
        )
    },

    data ()
    {
        return {
            currentValue: '',
            isFocused: false,
        }
    },

    computed:
    {
        placeholderValue ()
        {
            if (StringUtils.isEmptyString(StringUtils.removeHtmlTags(this.currentValue)))
            {
                return this.placeholder
            }
            else return ''
        }
    },

    watch:
    {
        value ()
        {
            this.currentValue = this.value
        },

        currentValue (val, old)
        {
            if (val == old) return
            
            if (this.noHtml)
            {
                this.currentValue = StringUtils.removeHtmlTags(this.currentValue)
            }

            // for binding with v-model prop.
            this.$emit('input', this.currentValue)
        }
    },

    beforeDestroy ()
    {
        window.removeEventListener('focus', this.onAnotherElementFocused)
    },

    methods:
    {
        onFocused ()
        {
            this.isFocused = true
            window.addEventListener('focus', this.onAnotherElementFocused, {passive: true, capture: true})
        },

        onAnotherElementFocused (e)
        {
            if (e.target instanceof HTMLInputElement || (e.target.contentEditable || '').toString() == 'true')
            {
                this.isFocused = false
            }

            window.removeEventListener('focus', this.onAnotherElementFocused)
        }
    },

    components:
    {
        VueEditor
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.inline-editable-text
{
    &:not(.has-toolbar)
    {
        .ql-toolbar
        {
            display: none;
        }
    }

    div, p
    {
        color: inherit;
    }

    #input
    {
        border: none;
        width: 100%;
        text-align: inherit;
        overflow: hidden;
        display: block;
        padding: inherit;
    }

    .quillWrapper
    {
        .ql-toolbar.ql-snow
        {
            border: none;
            padding: 0;
        }

        .ql-container.ql-snow
        {
            border: none;

            & .ql-snow
            {
                border: inherit;
            }
        }

        .ql-editor
        {
            min-height: 0;
            text-align: inherit;
            padding-left: 0;
            padding-right: 0;

            &.ql-blank
            {
                &::before
                {
                    left: 0;
                    right: 0;    
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/InlineEditableText.vue